import { Component, Output } from '@angular/core';
import { BroadcastService } from '../../../core/broadcast/broadcast.service';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  selector: 'kng-profile-header-button',
  templateUrl: './kng-profile-header-button.component.html',
  styleUrls: []
})
export class KngProfileHeaderButton {

  constructor(private broadcast: BroadcastService, private auth: AuthService) { }

  logout() {
    this.auth.logout();
  }

  openProfile() {
    this.broadcast.emit('kng-profile.open');
  }

  isLoggedIn() {
    return this.auth.isLoggedIn();
  }

  login() {
    this.auth.login();
  }

  getUser() {
    return this.auth.getAuthUser();
  }

  getInitials() {
    const user = this.getUser();

    return user.fName.charAt(0) + user.lName.charAt(0);
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-profile-header-button/kng-profile-header-button.component.ts